import React from "react";
import {NavLink } from "react-router-dom";

function CardV2(props) {
  return (
    <div className={props.classList}>
      <div className="product-img">
        <img src={props.backImgSrc} alt="" />
      </div>

      {/* Product Content */}
      <div className="product-content">
        {/* Owners */}
        <div className="owners">
          {props.profileImages.map((content, index) => (
            <NavLink key={index} to="profile.html" title={content.title}>
              <img src={content.imgSrc} alt="" />
            </NavLink>
          ))}
          <span className="user-status white">
            <img src={props.statusImgSrc} className="svg" alt="" />
          </span>
        </div>
        {/* End Owners */}

        <div className="product-top">
          <h5>{props.heading}</h5>
          <div className="d-flex justify-content-between">
            <h6 className="c1">{props.price}</h6>
            <h6>{props.info}</h6>
          </div>
        </div>

        <div className="product-bottom">
          {/* Button Group */}
          <div className="d-flex justify-content-between">
            {props.timeLeft !== undefined ? (
              <div className="countdown-wrap">
                <ul className="countdown">
                  <li>
                    <span className="hours">{props.timeLeft.hours}</span>
                  </li>
                  <li className="ms-1 me-1"> : </li>
                  <li>
                    <span className="minutes">{props.timeLeft.minutes}</span>
                  </li>
                  <li className="ms-1 me-1"> : </li>
                  <li>
                    <span className="seconds">{props.timeLeft.seconds}</span>
                  </li>
                </ul>
              </div>
            ) : (
              <div className="d-flex align-items-center ml-n2">
                <div className="love-react style--two"></div>
                <div className="love-count">{props.likes}</div>
              </div>
            )}

            <NavLink to="item-details.html" className="btn btn-border btn-sm">
              <img src="/img/icons/judge-icon.svg" alt="" className="svg" />
              Place Bid
            </NavLink>
          </div>
          {/* End Button Group */}
        </div>
      </div>
      {/* End Product Content */}
    </div>
  );
}

export default CardV2;
